
<div class="basin-p-x-1 basin-pt-1" *ngIf="!isTerrainStatusFailed(terrainLoadingStatus$ | async) && (demFileUploading$ | async)">
  <div class="basin-display-flex basin-flex-row basin-justify-content-space-between basin-align-items-center basin-width-100 basin-mb-1">
    <div
      class="basin-subtitle-small basin-color-mid-gray basin-font-weight-400"
    >
      Terrain Status
    </div>
    <basin-tag
      icon="symbol-sync"
      theme="info"
      [value]="getUploadStatus(demFileUploadStatus$ |async)"></basin-tag>
  </div>
</div>

<div class="basin-p-x-1 basin-pt-1" *ngIf="isTerrainStatusFailed(terrainLoadingStatus$ | async)">
  <div class="basin-display-flex basin-flex-row basin-justify-content-space-between basin-align-items-center basin-width-100 basin-mb-1">
    <div
      class="basin-subtitle-small basin-color-mid-gray basin-font-weight-400"
    >
      Terrain Status
    </div>

    <basin-tag
      icon="symbol-error"
      theme="error"
      value="Failed"></basin-tag>
  </div>
</div>
